import base from "D:/Adi/Personal/Project/monochrome/images/apple.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");